import { render, staticRenderFns } from "./thankYou.vue?vue&type=template&id=1d9e879e"
import script from "./thankYou.vue?vue&type=script&async=true&lang=js"
export * from "./thankYou.vue?vue&type=script&async=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports